// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: labels the relocate panel and the phone-width selection bar share (relocation parity: the same lines
// as Obyrus' bar and sheet). Exclude from upstream sync.

import Channels from '@app/features/channel/state/Channels';
import {
	movedBackText,
	movedText,
	NOTHING_MOVED,
	RelocationStrings,
	selectionCountText,
	stoppedText,
} from '@app/features/channel/state/RelocationStrings';
import SelectMode, {type RelocationResult} from '@app/features/channel/state/SelectMode';
import * as ChannelUtils from '@app/features/channel/utils/ChannelUtils';

/** The selection's status line (Obyrus' bar): what to select next, or how many are selected. */
export {selectionCountText};

export function selectionStatusText(_channelId: string | null): string {
	if (SelectMode.anchorId == null) return RelocationStrings.startPlaceholder;
	if (SelectMode.headId == null) return RelocationStrings.endPlaceholder;
	return selectionCountText(SelectMode.selectionCount);
}

/** "#name" for a server channel, the DM's display name for a DM, else the logged name or the id. */
export function channelLabel(id: string, loggedName?: string | null): string {
	const channel = Channels.getChannel(id);
	if (channel) {
		return channel.guildId ? `#${channel.name ?? id}` : ChannelUtils.getDMDisplayName(channel);
	}
	return loggedName ? `#${loggedName}` : id;
}

/** The result line: moved, moved back, stopped, or nothing to move. */
export function relocationResultText(result: RelocationResult): string {
	const destination = channelLabel(result.destChannelId);
	if (result.movedCount === 0) return NOTHING_MOVED;
	if (result.undo) return movedBackText(result.movedCount, destination);
	if (result.stopped) return stoppedText(result.movedCount, result.total);
	return movedText(result.movedCount, destination);
}
